import React from "react";
import { DownwardArrow } from "./DownArrowRed.styles";

const DownArrowRed = () => {
    return (
        <DownwardArrow />
    )
}

export default DownArrowRed;